import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MailAccountsService } from './mail-accounts.service';
import { MailAccountModel } from './mail-account.model';

@Component({
  selector: 'app-connect-mail-account-dialog',
  templateUrl: './connect-mail-account-dialog.component.html',
  styleUrls: ['./connect-mail-account-dialog.component.css'],
  standalone: false,
})
export class ConnectMailAccountDialogComponent implements OnInit {

  form: FormGroup;
  saving = false;

  constructor(
    private dialogRef: MatDialogRef<ConnectMailAccountDialogComponent>,
    private mailAccountsService: MailAccountsService,
    private snackBar: MatSnackBar,
  ) { }

  ngOnInit(): void {
    this.form = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
      password: new FormControl('', [Validators.required]),
      imapHost: new FormControl('imap.gmail.com', [Validators.required]),
      imapPort: new FormControl(993, [Validators.required]),
      fechaDesde: new FormControl(null),
    });
  }

  conectar(): void {
    if (this.form.invalid || this.saving) {
      return;
    }

    this.saving = true;

    const value = this.form.value;

    this.mailAccountsService.connect({
      email: value.email,
      password: value.password,
      imapHost: value.imapHost,
      imapPort: value.imapPort,
      fechaDesde: value.fechaDesde ? value.fechaDesde.toISOString() : null,
    }).then(
      (account: MailAccountModel) => {
        this.saving = false;
        this.dialogRef.close(account);
      },
      err => {
        this.saving = false;
        const message = (err && typeof err.error === 'string')
          ? err.error
          : 'No se pudo conectar el buzón. Revisa los datos e inténtalo de nuevo.';
        this.snackBar.open(message, 'Cerrar', { duration: 6000 });
      }
    );
  }

  cancelar(): void {
    this.dialogRef.close(null);
  }
}
